
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'NumberInput',
  emits: ['update:value'],
  props: {
    value: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const inputValue = ref<string>();

    function onChange(event: any) {
      updateModel(event.value);
    }

    function updateModel(newValue: any) {
      emit('update:value', newValue);
    }

    return {
      onChange,
      inputValue,
    };
  },
});
